import marked from 'marked'

export default {
  install: () => {
    marked.use({ extensions: []})
  }
}
